import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { untilDestroyed } from 'ngx-take-until-destroy';
import {
  hasConsentPdfScalarAnswer,
  shouldShowConsentPdfNotAnswered
} from 'src/app/core/api/consent-form.util';
import { FormTemplateGeneratorService } from '../../form-template-generator.service';
import { DateConfig, FormFieldConfig } from './../../../form-template-model';

@Component({
  selector: 'csi-form-template-date-field-generator',
  templateUrl: './form-template-date-field-generator.component.html',
  styleUrls: ['./form-template-date-field-generator.component.css']
})
export class FormTemplateDateFieldGeneratorComponent implements OnInit, OnDestroy {
  @Input() config: FormFieldConfig & { typeConfig: DateConfig };
  @Input() control: FormControl;
  @Input() formTemplateFieldKey: string;
  @Input() readOnly: boolean;
  @Input() formatForPDF: boolean;
  @Input() supportingFields: { [key: string]: FormFieldConfig };
  /** Consent forms: display dates as July 10, 2026 (en-US), not locale-short formats. */
  @Input() isConsentForm: boolean = false;

  public maxDate: Date | null = null;
  public notApplicableFormControl = new FormControl(false);
  /** Consent PDF: show when optional date was left blank. */
  public showNotAnswered = false;

  /** Consent locked/read-only dates: disabled mat-form-field instead of plain text. */
  get isConsentLockedDate(): boolean {
    return (
      this.isConsentForm &&
      !this.formatForPDF &&
      !!(this.readOnly || (this.config && this.config.typeConfig && this.config.typeConfig.lockedToToday))
    );
  }

  constructor(public formTemplateGeneratorService: FormTemplateGeneratorService) {}

  ngOnInit() {
    if (this.config && this.config.typeConfig) {
      if (this.config.typeConfig.maxDateToday === true) {
        this.maxDate = new Date();
      }

      if (this.config.typeConfig.lockedToToday && !this.readOnly && !this.formatForPDF) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        this.control.setValue(today);
        this.control.disable({ emitEvent: false });
      }

      if (this.config.typeConfig.showNotApplicableOption) {
        if (this.control.value === 'N/A' && (this.formatForPDF || this.readOnly)) {
          this.notApplicableFormControl.setValue(true);
        }
        if (!this.readOnly) {
          this.notApplicableFormControl.valueChanges
            .pipe(untilDestroyed(this))
            .subscribe(notApplicable => {
              if (notApplicable) {
                this.control.setValue('N/A');
                this.control.setErrors(null); // Remove default mat datepicker validation errors to allow for 'N/A'
              } else {
                this.control.setValue(null);
              }
            });
        } else {
          this.notApplicableFormControl.disable();
        }
      }
    }

    this.showNotAnswered = shouldShowConsentPdfNotAnswered(
      this.isConsentForm,
      this.formatForPDF,
      this.notApplicableFormControl.value ||
        hasConsentPdfScalarAnswer(this.control && this.control.value)
    );
  }

  ngOnDestroy() {}
}
